const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  index ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/shipping-rate/index', { params })
  },
  calc ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/shipping-rate/calc', { params })
  },
  searchAddlSeahmde ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/shipping-rate/search-addl-seahmde', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
